import { send } from 'ms-email/api/send-map-access-request'
import { useQueryParams } from 'ssr/router'
import { useAuth } from 'user-auth'

import { useMutation } from '@tanstack/react-query'

import { useGetMapByIdForPublic } from './useGetMapByIdForPublic'

export function useSendAccessRequest() {
  const { mapId } = useQueryParams()

  const { user } = useAuth()
  const { data: map } = useGetMapByIdForPublic()

  return useMutation({
    mutationKey: ['sendAccessRequest', mapId],
    mutationFn: async () => {
      await send({ user, map }, [map?.creator?.email])
    }
  })
}
